import React from 'react';
import { useNavigate } from 'react-router-dom'; // <- import useNavigate
import './ProductCatagories.css';

const ProductCategories = () => {
  const navigate = useNavigate();

  const handleClick = (PageLink) => {
    navigate(`/products/${PageLink}`); // <- dynamic route
  };

  return (
    <div className="mainHome-container">
      <section className="product-categories" style={{ height: "auto", paddingBottom: "50px" }}>
        <h2>Our Product Categories</h2>
        <p>Explore our diverse range of products across multiple industries</p>
        <section className="product-categories-list">
          <div className="product-categories-list-grid">
            {productCategory.map((productCategory, index) => (
              <div
                key={index}
                className="product-categories-list-box"
                onClick={() => handleClick(productCategory.PageLink)} // <- add onClick
                style={{ cursor: 'pointer' }}
              >
                <div className="icon">
                  <img
                    src={productCategory.image}
                    alt={productCategory.image}
                    className="product-section-img"
                  />
                </div>
                <h3>{productCategory.title}</h3>
                <p>{productCategory.description}</p>
              </div>
            ))}
          </div>
        </section>
        {/* <button className="view-button">View All Products</button> */}
      </section>
    </div>
  );
};

export default ProductCategories;

// Now each product has a slug to use in the route
const productCategory = [
  {
    title: "Alloy Metal Scrap",
    description: "High-grade scrap from alloyed metals for industrial reuse.",
    image: "/Products/AlloyMetalScrap.jpg",
    PageLink: "alloy-metal-scrap"
  },
  {
    title: "Non-Alloy Metal Scrap",
    description: "Raw, non-alloyed scrap ideal for basic metal processing.",
    image: "/Products/Non-AlloyMetalScrap.jpg",
    PageLink: "non-alloy-metal-scrap"
  },
  {
    title: "Ferrous Metal",
    description: "Iron-based scrap materials sourced from heavy machinery.",
    image: "/Products/img3.jpg",
    PageLink: "ferrous-metal"
  },
  {
    title: "Non-Ferrous Metal",
    description: "Copper, aluminum, and other non-iron scrap metals.",
    image: "/Products/Non-FerrousMetal.avif",
    PageLink: "non-ferrous-metal"
  },
  {
    title: "Specialty & Mixed Scrap",
    description: "Blended scrap materials including rare and specialty metals.",
    image: "/Products/mixed.avif",
    PageLink: "specialty-mixed-scrap"
  },
  {
    title: "Agro Products",
    description: "Naturally harvested goods ready for export and trade.",
    image: "/Products/agro.avif",
    PageLink: "agro-products-export"
  },
  {
    title: "Agriculture Commodities",
    description: "Staple grains, oilseeds, and other high-demand agricultural goods for domestic and international markets.",
    image: "/Products/Agriculture.jpeg",
    PageLink: "agriculture-commodities"
  },
  {
    title: "Medical Equipment",
    description: "Reliable, industry-standard medical equipment and tools.",
    image: "/Products/medical.avif",
    PageLink: "medical-equipment"
  }
];

